import { QueryClient } from '@tanstack/react-query'
import { client } from './client/client.gen'
import { showToast, translate } from './lib';
import { useStore } from './store';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 30000,
    },
  },
})

client.interceptors.response.use(async(response, request) => {
  if (response.status !== 200) {
    // Detect request method
    const requestMethod = request.method; // 'GET', 'POST', 'PUT', etc.
    const { errors: _ } = useStore.getState()
    // Clone the response before reading its body to avoid consuming the stream
    const resData = await response.clone().json()
    const msgCode = resData?.message || resData?.error
    // You can now handle different methods differently
    if (requestMethod === 'POST') {
      console.log(msgCode)  
      showToast(translate(msgCode))
    } else if (requestMethod === 'GET') {
      // Handle GET-specific logic
    }
  }
  return response;
});